'use strict';
var $ = require('jquery');

function init(dataEl, col1Label, col2Label) {
	if (!google && !dataEl.length){
		return;
	}

	var dataArray = [[col1Label, col2Label]];
	var colorArray = [];
	for (var i = 0; i < dataEl.length; i++) {
		dataArray.push(parseDataItem(dataEl[i]));
		colorArray.push(parseItemColor(dataEl[i]));
	}

	var chart;
	var data;
	var options;

	google.charts.load('current', {'packages':['corechart']});
	google.charts.setOnLoadCallback(setupChart);

	function parseDataItem(item) {
		var label = item.getAttribute('data-label');
		var percentage = Number.parseFloat(item.getAttribute('data-number'));
		return [label, percentage];
	}
	function parseItemColor(item) {
		var color = item.getAttribute('data-color');
		return color;
	}
	function drawChart() {
		chart.draw(data, options);
	}
	function setupChart() {
		chart;
		data = google.visualization.arrayToDataTable(dataArray);
		options = {
			pieHole: 0.65,
			pieSliceText: 'none',
			pieStartAngle: 140,
			legend: 'none',
			colors: colorArray,
			tooltip: { trigger: 'none' },
			backgroundColor: 'none',
			chartArea: {
				width: '100%',
				height: '100%'
			},
			width: 200
		};

		chart = new google.visualization.PieChart(document.getElementById('diversityChart'));
		drawChart();
		$(window).on('resize', drawChart);
	}
}

module.exports = {
	init: init
}